import { createAction, handleActions } from "redux-actions";
import produce from "immer";
import { takeLatest } from "redux-saga/effects";
import createRequestSaga, {
  createRequestActionType,
} from "../lib/createRequestSaga";
import * as problemAPI from "../lib/api/problem";

const CHANGE_FIELD = "problem/CHANGE_FIELD";
const PUSH_ELEMENT = "problem/PUSH_ELEMENT";
const INITIALIZE_FORM = "problem/INITIALIZE_FORM";
const [SELECT, SELECT_SUCCESS, SELECT_FAILURE] =
  createRequestActionType("problem/SELECT");
const [ANS_CHECK, ANS_CHECK_SUCCESS, ANS_CHECK_FAILURE] =
  createRequestActionType("problem/ANS_CHECK");

export const changeField = createAction(
  CHANGE_FIELD,
  ({ form, key, value }) => ({
    form,
    key,
    value,
  })
);

export const pushElement = createAction(PUSH_ELEMENT, (ele) => ele);
export const initializeForm = createAction(INITIALIZE_FORM, (form) => form);
export const select = createAction(SELECT);

export const ans_check = createAction(
  ANS_CHECK,
  ({ problem_id, ansinput }) => ({ problem_id, ansinput })
);

const selectSaga = createRequestSaga(SELECT, problemAPI.select_problem);
const ans_checkSaga = createRequestSaga(ANS_CHECK, problemAPI.ans_check);
export function* problemSaga() {
  yield takeLatest(SELECT, selectSaga);
  yield takeLatest(ANS_CHECK, ans_checkSaga);
}

/*
 api 문서 참고
 next는 다음 문제 출제를 위한 플래그
*/
const initialState = {
  problem_info: {
    problem_id: "",
    trans_problem_id: "",
    domain: "",
    problem_type: "",
    problem_answer: "",
    ansinput: "",
    is_right: null,
  },
  solved_problems: [],
  solved_domains: {
    domain_cds: [],
  },
  select: null,
  selectError: null,
  next: null,
  ansCheckError: null,
  domainNames: [],
};

const problem = handleActions(
  {
    [CHANGE_FIELD]: (state, { payload: { form, key, value } }) =>
      produce(state, (draft) => {
        draft[form][key] = value;
      }),
    [PUSH_ELEMENT]: (state, { payload: element }) => ({
      ...state,
      solved_problems: [...state.solved_problems, element],
      next: true,
    }),
    [INITIALIZE_FORM]: (state, { payload: form }) => ({
      ...state,
      [form]: initialState[form],
      select: null,
      selectError: null,
      ansCheckError: null,
      next: null,
    }),
    [SELECT_SUCCESS]: (state, { payload: form }) => ({
      ...state,
      select: form,
    }),
    [SELECT_FAILURE]: (state, { payload: error }) => ({
      ...state,
      select: error,
      selectError: true,
    }),
    [ANS_CHECK_SUCCESS]: (state, { payload: form }) =>
      produce(state, (draft) => {
        draft[form.form][form.key] = form.value;
      }),
    [ANS_CHECK_FAILURE]: (state, { payload: error }) => ({
      ...state,
      ansCheckError: true,
    }),
  },
  initialState
);

export default problem;
